import * as React from 'react';
import {
  Button,
  ButtonBadge /* IconButton */,
  IconButton,
} from 'naan/primitives/button';
import { Menu, MenuItem } from 'naan/primitives/menus';
import { Responsive } from 'naan/primitives/responsive';
import { PlusIcon } from 'naan/icons/plus-icon';
import { HStack } from 'naan/primitives/stack';
import { FavoriteFilledIcon } from 'naan/icons/favorite-filled-icon';
import { FavoriteIcon } from 'naan/icons/favorite-icon';

import __ from 'core/lib/localization';

type VolumeCardHeaderControlsProps = {
  isFavorited?: boolean;
  onClassAssignment: () => void;
  onFavorite: () => void;
  badgeCount?: number;
  storySlug: string;
};

const TeacherVolumeHeaderDropdown = ({
  onClassAssignment,
  onFavorite,
  isFavorited,
}: VolumeCardHeaderControlsProps) => {
  return (
    <Menu>
      <MenuItem
        label={__('Assign to class', 'assignToClass')}
        action={() => {
          // otherwise we get a race condition and te assignment modal never shows up
          requestAnimationFrame(onClassAssignment);
        }}
        leftIcon={<PlusIcon />}
      />
      <MenuItem
        label={
          isFavorited
            ? __('Remove from favorites', 'removeFavorites')
            : __('Add to favorites', 'addFavorites')
        }
        action={onFavorite}
        leftIcon={isFavorited ? <FavoriteFilledIcon /> : <FavoriteIcon />}
      />
    </Menu>
  );
};

export const TeacherVolumeCardHeaderButtons = ({
  onClassAssignment,
  onFavorite,
  isFavorited,
  badgeCount,
  storySlug,
}: VolumeCardHeaderControlsProps) => {
  return (
    <HStack gap="small">
      <Button
        presentation={badgeCount ? 'activated' : 'secondary'}
        label={__('Assign to class', 'assignToClass')}
        onClick={onClassAssignment}
        rightIcon={badgeCount ? <ButtonBadge>{badgeCount}</ButtonBadge> : null}
      />
      <IconButton
        presentation={isFavorited ? 'tealLight' : 'grayLight'}
        icon={isFavorited ? <FavoriteFilledIcon /> : <FavoriteIcon />}
        onClick={onFavorite}
        testId={`favorite-toggle-button-${storySlug}`}
      />
    </HStack>
  );
};

export const ResponsiveTeacherVolumeCardHeaderControls = ({
  isFavorited = false,
  onClassAssignment,
  onFavorite,
  badgeCount = 0,
  storySlug,
}: VolumeCardHeaderControlsProps) => {
  return (
    <Responsive
      renderDefault={() => (
        <TeacherVolumeHeaderDropdown
          onClassAssignment={onClassAssignment}
          onFavorite={onFavorite}
          isFavorited={isFavorited}
          storySlug={storySlug}
        />
      )}
      renderMediumAndUp={() => (
        <TeacherVolumeCardHeaderButtons
          onClassAssignment={onClassAssignment}
          onFavorite={onFavorite}
          isFavorited={isFavorited}
          badgeCount={badgeCount}
          storySlug={storySlug}
        />
      )}
    />
  );
};
